// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"AdvancedSearch":"6328bd1272cf9c43fddd","Details":"4771cd352a91898536e6","StyleGuide":"85809f480c2d99ee91d7"}[chunkId] + ".js";
};